import React from 'react'
import Paper from '@material-ui/core/Paper'
import { styles } from './styles'
import logo from '../../assets/images/g2g-logo.png'
import appStore from '../../assets/images/app-store-1.png'
import googlePlay from '../../assets/images/google-play.png'
import heroLogo from '../../assets/images/icon_hero_green2get.png'
import { Typography } from 'antd'

const { Title } = Typography

export const StartPage = () => {
  return (
    <main>
      <Paper elevation={0} square style={styles.paper}>
        <div style={styles.logoWrapper}>
          <img src={logo} alt="logo" style={styles.logo} />
        </div>
        <div style={styles.heroLogoWrapper}>
          <img src={heroLogo} alt="heroLogo" style={styles.heroLogo} />
        </div>
        <div style={{ textAlign: 'center' }}>
          <Title
            level={2}
            style={{
              fontSize: '2.2vh',
              color: '#6ebf4b',
              fontFamily: 'Sarabun'
            }}>
            เปลี่ยนไปใช้งานผ่านแอปพลิเคชั่น ฮีโร่รีไซเคิล
          </Title>
          <Title
            level={2}
            style={{
              fontSize: '2.2vh',
              color: '#6ebf4b',
              fontFamily: 'Sarabun',
              marginTop: '-10px'
            }}>
            จะซื้อจากลูกค้า ขายให้โรงงาน ง่ายๆ แค่ปลายนิ้ว
          </Title>
        </div>
        <div style={styles.buttonWrapper}>
          <div style={styles.appWrapper}>
            <a href="https://apps.apple.com/us/app/green2get-%E0%B8%AE-%E0%B9%82%E0%B8%A3/id1603992093">
              <img src={appStore} alt="appStore" style={styles.appleStore} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.green2get.hero.app">
              <img
                src={googlePlay}
                alt="googlePlay"
                style={styles.googlePlay}
              />
            </a>
          </div>
        </div>
      </Paper>
    </main>
  )
}

export default StartPage



// WEBPACK FOOTER //
// ./src/pages/StartPage/index.js